<template>
<div class="Signer-container mb-2 bg-white text-text-secondary">
  <div>
    <app-material-icon name="drag_indicator" color="icon-secondary" class="Signer-grabIcon mr-2" />
    {{signer.fullName}}
  </div>
  {{index}}

</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'

export default defineComponent({
  name: 'SignersOrderQualifiedSigner',
  props: {
    signerId: {
      type: Number,
      required: true,
    },
    index: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    ...mapGetters('groups', ['allRoomMembers']),
    signer () {
      return this.allRoomMembers.find((member: ObjectWith<{ id: number }>) => member.id === this.signerId)
    },
  },
})
</script>

<style scoped lang="scss">
.Signer {
  &-container {
    background: rgb(var(--v-theme-surface-primary));
    border: 1px solid rgb(var(--v-theme-border-secondary));
    border-radius: 4px;
    padding: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &-grabIcon {
    cursor: grab;
  }
}
</style>
